import {i18nKey} from '@/locales/i18n';
import dayjs from 'dayjs';

export enum USAGE_LIST_FILTER {
  DEPARTMENT = 'department',
  STATUS = 'status',
}

export const CURRENT_RANGE_MONTH = [dayjs(new Date()), dayjs(new Date())];

export const USAGE_STATUS_LIST = [
  {value: 4, label: () => i18nKey.Status.Usage.all},
  {value: 1, label: () => i18nKey.Status.Usage.normal},
  {value: 2, label: () => i18nKey.Status.Usage.closeToLimit},
  {value: 3, label: () => i18nKey.Status.Usage.fullCapacity},
];
